
import { Component, Vue, Watch } from "vue-property-decorator";
import { Notify } from "quasar";

interface dataButton {
  id: number | any;
  titulo?: string;
  subtitulo?: string;
  uri?: string;
  color?: string;
  img?: string;
  subMenu?: Array<dataButton>;
}

@Component({
  components: {}
})
export default class FirstToolbarComponent extends Vue {
  private win = window;

  private buttonsNetworks: Array<dataButton> = [
    {
      id: 1,
      img: require("../../../assets/Web/Face-blanco.png"),
      uri: "https://www.facebook.com/munimaipu/"
    },
    {
      id: 2,
      img: require("../../../assets/Web/x-blanco.png"),
      uri: "https://x.com/muni_maipu"
    },
    {
      id: 3,
      img: require("../../../assets/Web/Insta-blanco.png"),
      uri: "https://www.instagram.com/muni_maipu/"
    },
    {
      id: 4,
      img: require("../../../assets/Web/Youtube-blanco.png"),
      uri: "https://www.youtube.com/channel/UCNHAaMlDOY3TXBr_3kNHV5A"
    },
    {
      id: 5,
      img: require("../../../assets/Web/in-blanco.png"),
      uri: "https://cl.linkedin.com/company/municipalidad-maipu"
    },
    {
      id: 6,
      img: require("../../../assets/Web/Tiktok-blanco.svg"),
      uri: "https://www.tiktok.com/@muni_maipu"
    }
  ];

  private buttons: Array<dataButton> = [
    {
      id: 1,
      titulo: "LEY DEL LOBBY",
      subtitulo: "Plataforma",
      uri: "https://www.leylobby.gob.cl/instituciones/MU163",
      color: "#E60380"
    },
    {
      id: 2,
      titulo: "LEY DE TRANSPARENCIA",
      subtitulo: "Transparencia activa",
      uri:
        "https://www.portaltransparencia.cl/PortalPdT/directorio-de-organismos-regulados/?org=MU163",
      color: "#E60380"
    },
    {
      id: 3,
      titulo: "LEY DE TRANSPARENCIA",
      subtitulo: "Solicitar información",
      uri:
        "https://www.portaltransparencia.cl/PortalPdT/web/guest/directorio-de-organismos-regulados?p_p_id=pdtorganismos_WAR_pdtorganismosportlet&orgcode=5af3874dfe478f30366568cc1631d681",
      color: "#E60380"
    },
    {
      id: 4,
      titulo: "MÁS SITIOS",
      uri: "/mas-sitios",
      color: "#FFB71B"
    }
  ];

  private mounted() {}

  private routerGo(name: string) {
    if (name && name != "") {
      if (this.$router.currentRoute.name == name) {
        this.$router.go(0);
      } else {
        this.$router.push({ name: name }).catch(err => {
          console.log(err);
        });
      }
    }
  }
}
